// Снег в секциях: на элементе data-snow, снежинки летят только внутри него
import Snowflakes from "magic-snowflakes"

export function initSnow() {
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

	const isMobile = window.matchMedia('(max-width: 767px)').matches

	document.querySelectorAll('[data-snow]').forEach((el) => {
		const snow = new Snowflakes({
			container: el,
			color: '#ffffff',
			count: isMobile ? 50 : 120,
			minSize: 8,
			maxSize: 18,
			minOpacity: 0.85,
			maxOpacity: 1,
			speed: 0.6,
			rotation: true,
			wind: true,
			zIndex: 1,
		})

		// По умолчанию снежинки стартуют над блоком с задержкой до полного времени падения.
		// Отрицательная задержка: на старте они уже на разной высоте внутри блока
		el.querySelectorAll('.snowflake').forEach((flake) => {
			const duration = parseFloat(flake.style.animationDuration) || 0
			flake.style.animationDelay = -(Math.random() * duration) + 's'
		})

		// Вне экрана анимацию ставим на паузу
		new IntersectionObserver(([entry]) => {
			entry.isIntersecting ? snow.start() : snow.stop()
		}).observe(el)
	})
}
